export var PermissionArea;
(function (PermissionArea) {
    PermissionArea["PERMISSION_AREA_GLOBAL_MANAGEMENT"] = "GLOBAL_MANAGEMENT";
    PermissionArea["PERMISSION_AREA_CLOUD"] = "CLOUD";
    PermissionArea["PERMISSION_AREA_SAAS"] = "SAAS";
    PermissionArea["PERMISSION_AREA_STORAGE_GATEWAY"] = "STORAGE_GATEWAY";
})(PermissionArea || (PermissionArea = {}));
